import { Gesture } from "./BaseGesture"

export default function () {
  const { getCollectionViewFileFromEvent, state: gestureState, gestureLayers } = useGestures()
  const { selectedFiles } = useSelection()
  const { moveFiles } = useFileSystem()
    const { isAuthorizedToMoveToFolder, isAuthorizedToDragFiles } = useAuthorization()
    const { notifyError } = useAlerts()

  class CollectionViewFileDropOnFolderToMove extends Gesture {
    override layer = gestureLayers.mainView

    override reset() {
      this.switchMode("none")
    }

    override async onMouseUp(mouse: MouseEvent) {
      if (gestureState.value.gesture !== "drag-file")
        return

      const files = selectedFiles.value
      if (!len(files))
        return this.console.error("No selected files to drop")

      // if we dropped on another file
      const destination = getCollectionViewFileFromEvent(mouse)
      if (!destination)
        return

      if (!destination.isFolder()) {
        this.error("Invalid drop target", destination)
        return
      }
      
      this.debug("Dropped on a folder!", destination)
      this.capture()


    if (!isAuthorizedToDragFiles()) {
      this.error("Not authorized to drag files")
      return this.reset()
    }

    for (const file of Object.values(files)) {
      if (!isAuthorizedToMoveToFolder(file, destination)) {
        this.error("Not authorized to move a file to destination", file, destination)
        notifyError(
          "Action not allowed", 
          "You don't have permission to move one or more of the selected files to the destination folder."
        )
        return this.reset()
      }
    }

      this.switchMode("none")
      moveFiles(files, destination)
      return
      // This means we're just dropping into the page itself. This
      // could mean we just want to cancel the drag, or that we are
      // dragging in a file from the sidebar, or another window/tab?
    }
  }
  return new CollectionViewFileDropOnFolderToMove()
}
